import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

export const quantitiesAndUnitsNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'Quantity_other',
    route: { name: routenames.quantities.overview },
  },
  {
    titleI18n: 'Enumeration_other',
    route: { name: routenames.enumerations.overview },
  },
  {
    titleI18n: 'Text_other',
    route: { name: routenames.texts.overview },
  },
  {
    titleI18n: 'Unit_other',
    route: { name: routenames.units.overview },
  },
];
